<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="添加子标签"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="750px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap pr20 mt20">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="100px">
                <el-form-item label="标签归属：" class="mb8">
                    <span>{{data.dimension_name||'--'}}</span>
                </el-form-item>
                <el-form-item label="父标签名称：" class="mb8">
                    <span>{{data.name||'--'}}</span>
                </el-form-item>
                <el-form-item label="添加子标签：">
                    <div>
                        <el-input v-model.trim="tagInput" @keyup.enter.native.prevent.stop="addNames" placeholder="多个标签可用英文逗号分隔“,”" class="mr10" style="width: 320px;"></el-input>
                        <el-button type="primary" @click="addNames" size="mini" class="vertical-bottom" plain>
                            <i class="iconfont icon-jt-huichetijiao"></i>
                            <span class="relative ml4" style="top:-1px;">回车添加（Enter）</span>
                        </el-button>
                        <!--<span class="text-color-primary ml10"></span>-->
                    </div>
                </el-form-item>
                <el-form-item label="" prop="names">
                    <div class="tag-name-list">
                        <el-tag v-for="tag in formItem.names" :key="tag" closable class="mr10" @close="removeTag(tag)">{{tag}}</el-tag>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20" v-matomo="{behaviorCategory: '标签管理(标签维护)',name: '添加子标签(取消)' }">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20" v-matomo="{behaviorCategory: '标签管理(标签维护)',name: '添加子标签(保存)' }">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/baseInfo/tag.js';
    import matomoFun from "@/utils/matomo.js";

    export default {
        name: "AddLevel2TagModal",
        components:{},
        props:{
            data:Object,
        },
        data(){
            return {
                dialogVisible:false,
                formItem:{
                    names:[],
                },
                tagInput:'',
                rules:{
                    names:[
                        { type: 'array', required: true, message: '请添加标签'}
                    ]
                },
                submitLoading:false,
            }
        },
        methods:{
            handleClose(){
                matomoFun.trackEvent('标签管理(标签维护)', '点击', '添加子标签(取消)');
                this.resetForm();
                this.dialogVisible = false;
                this.$refs.form.clearValidate();
            },
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{

                })
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitLoading = true;
                        API.addLevel2Tag({
                            level1_id:this.data.id,
                            names:this.formItem.names.join(','),
                        }).then(res=>{
                            console.log('addLevel2Tag',res);
                            this.submitLoading = false;
                            this.$message.success(res.info||'操作成功');
                            this.hideModal();
                            this.$emit('update');
                        },err=>{
                            console.log('addLevel2Tag err',err);
                            this.submitLoading = false;
                            this.$message.error(err.info||'操作失败');
                        })
                    } else {
                        return false;
                    }
                });
            },
            hideModal(){
                console.log('hideModal');
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
                this.formItem.names = [];
                this.tagInput = '';
                this.submitLoading = false;
            },
            addNames(){
                console.log('addNames',this.tagInput);
                let tags = this.tagInput.split(',');

                let longTags = tags.find(item=>item.length>30);

                if(longTags){
                    this.$message.error('标签名称不可超过30个字：'+longTags.substr(0,30)+'...');
                }else{
                    tags.forEach(tag=>{
                        tag = tag.replace(/\s/g,'');
                        if(tag&&!this.formItem.names.includes(tag)){
                            this.formItem.names.push(tag);
                        }
                    });
                    this.tagInput = '';
                }
                this.$refs.form.validateField('names');
            },
            removeTag(tag){
                console.log('removeTag',tag);
                let index = this.formItem.names.findIndex(item=>item==tag);
                if(index!=-1){
                    this.formItem.names.splice(index,1);
                }
            },

        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-dialog__body{
        padding: 10px 30px 20px;
    }

    ::v-deep .word-limit-input input{
        padding-right: 80px;
    }

    .tag-name-list{
        max-height: 200px;
        overflow-y: auto;
    }
    .mb8{
        margin-bottom: 8px!important;
    }
</style>
